import React, { createContext, useContext } from 'react';
import schoolConfig from '../config/schools';

const SchoolContext = createContext(schoolConfig);

export const SchoolProvider = ({ children }) => (
  <SchoolContext.Provider value={schoolConfig}>
    {children}
  </SchoolContext.Provider>
);

export const useSchool = () => useContext(SchoolContext);
